module.exports = global["Tether"] = require("-!E:\\xampp\\htdocs\\OWL\\themes\\tiny\\site\\themes\\tiny\\_dev\\node_modules\\tether\\dist\\js\\tether.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?Tether!./~/tether/dist/js/tether.js
 ** module id = 2
 ** module chunks = 0
 **/